import React from 'react'
import { Parallax } from 'react-parallax'

class ContactUs extends React.Component {
  constructor(props) {
    super(props)
  }
  onFormSubmit = () => {
    // event.preventDefault()
    if(document.getElementById('first_name').value 
    && document.getElementById('last_name').value
    && document.getElementById('mobile').value
    && document.getElementById('email').value
     ){
      document.getElementById('field1').value = '00D3j0000002W3J';
      document.getElementById('00N3j00000FAAfx').value = this.props.location.href;
    }
  }
  render() {
    const { location, plan } = this.props;
    return (
      <section id="contacts" className="">
        <Parallax
          blur={0.1}
          bgImage={'/images/contact-us-dark.jpg'}
          bgImageSrcSet={
            '/images/contact-us-dark.jpg 4200w, /images/contact-us-1440.jpg 2000w, /images/contact-us-1024.jpg 1400w, /images/contact-us-mobile.jpg 800w'
          }
          bgImageAlt="contact us"
          strength={500}
        >
          <div className="container py-4">
            <div className="small-container mr-auto text-white text-center py-4">
              <h2 className="st-title text-white ttl-mr parallax-block__title-wrapper">
                Contact Us <span className="infity-color">Today</span>
              </h2>
              <h4 className="sub-heading text-white">
                Take your first steps in creating a brighter future
              </h4>
              <form
                className="text-center pt-3 "
                action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
                method="POST"
              >
                <div className="row">
                  <div className="form-group col-md-6 col-sm-12">
                    <input
                      className="input-gray input-control"
                      type="text"
                      name="first_name"
                      id="first_name"
                      required
                      placeholder="First Name"
                      aria-label="First-name"
                    />
                  </div>
                  <div className="form-group col-md-6 col-sm-12">
                    <input
                      className="input-gray input-control"
                      type="text"
                      name="last_name"
                      id="last_name"
                      required
                      placeholder="Last Name"
                      aria-label="Last-name"
                    />
                  </div>
                  <div className="form-group col-md-6 col-sm-12">
                    <input
                      className="input-gray input-control"
                      type="text"
                      name="mobile"
                      id="mobile"
                      required
                      placeholder="Phone No"
                      aria-label="Phone-No"
                    />
                  </div>
                  <div className="form-group col-md-6 col-sm-12">
                    <input
                      className="input-gray"
                      type="email"
                      name="email"
                      id="email"
                      required
                      placeholder="Email"
                      aria-label="email"
                    />
                  </div>
                  {/* <div className="form-group col-md-6 col-sm-12">
                    <input
                      className="input-gray input-control"
                      name="street"
                      type="text"
                      placeholder="Street Address"
                      aria-label="Street-Address"
                    />
                  </div> */}
                  <div className="form-group col-md-6 col-sm-12">
                    <input
                      id="city"
                      className="input-gray input-control"
                      maxLength="40"
                      name="city"
                      size="20"
                      type="text"
                      placeholder="City"
                      aria-label="City"
                    />
                  </div>
                  <div className="form-group col-md-6 col-sm-12">
                    <input
                      id="zip"
                      className="input-gray input-control"
                      maxLength="20"
                      name="zip"
                      size="20"
                      type="text"
                      placeholder="Zip Code"
                      aria-label="Zip-Code"
                    />
                  </div>
                  <div className="form-group col-md-6 col-sm-12">
                    <select
                      id="state_code"
                      className="form-control input-gray"
                      name="state_code"
                      aria-label="state-code"
                    >
                      <option value="">State</option>
                      <option value="AL">AL</option>
                      <option value="AK">AK</option>
                      <option value="AB">AB</option>
                      <option value="AZ">AZ</option>
                      <option value="AR">AR</option>
                      <option value="BC">BC</option>
                      <option defaultValue="CA" value="CA">
                        CA
                      </option>
                      <option value="CO">CO</option>
                      <option value="CT">CT</option>
                      <option value="DE">DE</option>
                      <option value="DC">DC</option>
                      <option value="FL">FL</option>
                      <option value="GA">GA</option>
                      <option value="HI">HI</option>
                      <option value="ID">ID</option>
                      <option value="IL">IL</option>
                      <option value="IN">IN</option>
                      <option value="IA">IA</option>
                      <option value="KS">KS</option>
                      <option value="KY">KY</option>
                      <option value="LA">LA</option>
                      <option value="ME">ME</option>
                      <option value="MB">MB</option>
                      <option value="MD">MD</option>
                      <option value="MA">MA</option>
                      <option value="MI">MI</option>
                      <option value="MN">MN</option>
                      <option value="MS">MS</option>
                      <option value="MO">MO</option>
                      <option value="MT">MT</option>
                      <option value="NE">NE</option>
                      <option value="NV">NV</option>
                      <option value="NB">NB</option>
                      <option value="NL">NL</option>
                      <option value="NH">NH</option>
                      <option value="NJ">NJ</option>
                      <option value="NM">NM</option>
                      <option value="NY">NY</option>
                      <option value="NC">NC</option>
                      <option value="ND">ND</option>
                      <option value="NT">NT</option>
                      <option value="NS">NS</option>
                      <option value="NU">NU</option>
                      <option value="OH">OH</option>
                      <option value="OK">OK</option>
                      <option value="ON">ON</option>
                      <option value="OR">OR</option>
                      <option value="PA">PA</option>
                      <option value="PE">PE</option>
                      <option value="QC">QC</option>
                      <option value="RI">RI</option>
                      <option value="SK">SK</option>
                      <option value="SC">SC</option>
                      <option value="SD">SD</option>
                      <option value="TN">TN</option>
                      <option value="TX">TX</option>
                      <option value="UT">UT</option>
                      <option value="VT">VT</option>
                      <option value="VA">VA</option>
                      <option value="WA">WA</option>
                      <option value="WV">WV</option>
                      <option value="WI">WI</option>
                      <option value="WY">WY</option>
                      <option value="YT">YT</option>
                    </select>
                  </div>
                  <div className="form-group col-md-6 col-sm-12">
                    <select
                      id="00N3j00000FA5A6"
                      name="00N3j00000FA5A6"
                      className="form-control input-gray"
                      title="Job Type"
                    >
                      <option value="">Job Type</option>
                      <option value="Roof">Roof</option>
                      <option defaultValue="Solar" value="Solar">
                        Solar
                      </option>
                      <option value="Battery">Battery</option>
                    </select>
                  </div>
                  <div className="col-sm-12 wow slideInDown fast animated">
                    <button
                      type="submit"
                      onClick={this.onFormSubmit}
                      className="rounded btn-yellow btn text-white btn get-a-quote get-started"
                    >
                      Get Started
                    </button>
                  </div>
                </div>
                <div className="success-message">
                  <i className="fa fa-check text-primary"></i> Thank you!. Your
                  message is successfully sent...
                </div>
                <div className="error-message">
                  We're sorry, but something went wrong
                </div>
                <div style={{ display: 'none' }}>
                  <input
                    id="lead_source"
                    name="lead_source"
                    type="hidden"
                    value="Website"
                  />
                  <input
                    id="00N3j00000FAAfJ"
                    name="00N3j00000FAAfJ"
                    type="hidden"
                    value="Quote Form"
                  />
                  <input name="oid" type="hidden" id="field1" value="" />
                  <input
                    name="retURL"
                    type="hidden"
                    value="https://infinityenergy.com/thank-you"
                  />
                  <input
                    id="country_code"
                    name="country_code"
                    type="hidden"
                    value="US"
                  />
                  <input
                    id="00N3j00000FAAfx"
                    name="00N3j00000FAAfx"
                    type="hidden"
                    value=""
                  />
                  <input
                    id="00N3j00000FpGp7"
                    name="00N3j00000FpGp7"
                    type="hidden"
                    value={plan ? plan : ''}
                  />
                <input  id="00N3j00000FpJyW" maxLength="150" name="00N3j00000FpJyW" size="20" type="hidden"/>
                {/* <input name="debug" type="hidden" value="1" />
                <input name="debugEmail" type="hidden" value="mohini@expansionjs.com" />   */}
                </div>
              </form>
              <p className="text-center mt-4 mb-0 text-white small-quote-msg">
                By submitting this form, you consent to receive emails, text
                messages and phone calls at any phone number you provide, even
                if the number is a wireless number. You agree that such calls
                and texts may be made using automated technology and that you
                are not required to provide consent to these calls to make a
                purchase from us.
              </p>
            </div>
          </div>
        </Parallax>
      </section>
    )
  }
}

export default ContactUs
